import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
// Registers window.virtualInspection for the host LiveSwitch app to call into.
import './liveswitch/bridge';
import { installDebugCapture } from './debug';
import './styles.css';

// Installed before anything renders, so a failure during startup is captured
// too rather than only the ones that happen once the UI is up.
installDebugCapture();

const root = document.getElementById('root');
if (!root) throw new Error('missing #root');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
